import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { IScanModule } from '@devinforius/i-scan';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { ITableModule } from '@devinforius/i-table';
import { INavigationModule } from '@devinforius/i-navigation';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { LoaderComponent } from './components/loader/loader.component';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { DividerModule } from 'primeng/divider';
import { SelectButtonModule } from 'primeng/selectbutton';
import { IconFieldModule } from 'primeng/iconfield';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { IViewerModule } from '@devinforius/i-viewer';
import { TimelineModule } from 'primeng/timeline';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { TreeModule } from 'primeng/tree';
import { SearchInputComponent } from './components/search-input/search-input.component';
import { BadgeModule } from 'primeng/badge';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MessagesModule } from 'primeng/messages';
import { SplitterModule } from 'primeng/splitter';
import { AccordionModule } from 'primeng/accordion';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TreeTableModule } from 'primeng/treetable';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { DragDropModule } from 'primeng/dragdrop';
import { FileSizePipe } from './pipes/file-size.pipe';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RippleModule } from 'primeng/ripple';
import { SkeletonModule } from 'primeng/skeleton';
import { TagModule } from 'primeng/tag';
import { ChartModule } from 'primeng/chart';
import { ChipModule } from 'primeng/chip';
import { CardModule } from 'primeng/card';
import { InputErrorMessageComponent } from './components/input-error-message/input-error-message.component';
import { MandateStatusChipComponent } from './components/mandate-status-chip/mandate-status-chip.component';
@NgModule({
  declarations: [
    LoaderComponent,
    SearchInputComponent,
    FileSizePipe,
    InputErrorMessageComponent,
    MandateStatusChipComponent,
  ],
  imports: [
    /*iCompos*/
    IEssentialsModule,
    ITableModule,
    INavigationModule,
    IViewerModule,
    IScanModule,
    /*PrimeNG*/
    DropdownModule,
    InputNumberModule,
    TooltipModule,
    ToastModule,
    DialogModule,
    ProgressBarModule,
    DividerModule,
    SelectButtonModule,
    IconFieldModule,
    PaginatorModule,
    InputTextModule,
    CalendarModule,
    TimelineModule,
    TableModule,
    MenuModule,
    MultiSelectModule,
    TreeModule,
    BadgeModule,
    ToggleButtonModule,
    MessagesModule,
    SplitterModule,
    AccordionModule,
    InputSwitchModule,
    TreeTableModule,
    ConfirmPopupModule,
    CheckboxModule,
    ConfirmDialogModule,
    FileUploadModule,
    DragDropModule,
    RadioButtonModule,
    RippleModule,
    SkeletonModule,
    TagModule,
    ChipModule,
    ChartModule,
    CardModule,
    /*Others*/
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
  ],
  exports: [
    /*iCompos*/
    IEssentialsModule,
    ITableModule,
    INavigationModule,
    IViewerModule,
    IScanModule,
    /*PrimeNG*/
    DropdownModule,
    InputNumberModule,
    TooltipModule,
    ToastModule,
    DialogModule,
    ProgressBarModule,
    DividerModule,
    SelectButtonModule,
    IconFieldModule,
    PaginatorModule,
    InputTextModule,
    CalendarModule,
    TimelineModule,
    TableModule,
    MenuModule,
    MultiSelectModule,
    TreeModule,
    BadgeModule,
    ToggleButtonModule,
    MessagesModule,
    SplitterModule,
    AccordionModule,
    InputSwitchModule,
    TreeTableModule,
    ConfirmPopupModule,
    CheckboxModule,
    ConfirmDialogModule,
    FileUploadModule,
    DragDropModule,
    RadioButtonModule,
    RippleModule,
    SkeletonModule,
    TagModule,
    ChipModule,
    ChartModule,
    CardModule,
    /*Others*/
    LoaderComponent,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule,
    SearchInputComponent,
    FileSizePipe,
    InputErrorMessageComponent,
    MandateStatusChipComponent,
  ],
})
export class SharedModule {}
